/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 * Application Constants
 */

// Avoid breaking changes.
// Exporting Constants that were part of this package but have been moved over to @spm/core
import { LIBRARY_ROOT } from '@spm/core';
export default {
  LIBRARY_ROOT: LIBRARY_ROOT
};